// Registre des champs de saisie de l'aperçu du formulaire, indexés par clé de
// variable ou identifiant de box. Il permet à un bouton rendu *à côté* du champ
// (les valeurs prédéfinies, dans le libellé de la ligne) d'écrire à la position
// du curseur, alors que le curseur n'est connu que du champ lui-même.
//
// Volontairement hors du store zustand : rien ici ne doit déclencher de rendu,
// et les fonctions enregistrées changent à chaque frappe.
const activeFields = new Map();

// Retourne la fonction de désinscription, à rendre telle quelle depuis un effet.
export const registerActiveField = (key, api) => {
  if (!key) return () => {};
  activeFields.set(key, api);
  return () => {
    // Un autre champ a pu prendre la place entre-temps (remontage) : ne pas
    // effacer l'inscription de quelqu'un d'autre.
    if (activeFields.get(key) === api) activeFields.delete(key);
  };
};

// Éditeur d'une box du document en cours d'édition (cf. RichEditor). Clé
// distincte de celle de l'aperçu du formulaire, qui inscrit la même box sous
// son id.
export const documentEditorKey = (boxId) => `document:${boxId}`;

export const getActiveField = (key) => (key ? activeFields.get(key) ?? null : null);
